<PreventiveMaintenanceCommonDetail headerText="Preventive Maintenance"  ListURL="DialysisMachine/PreventiveMaintenanceSearch" detailsType="Common"
></PreventiveMaintenanceCommonDetail>